import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { ScheduleSubjectRequest, ScheduleSubjectResponse } from "../../models/dtos";
import { scheduleApi } from "../schedule/scheduleApi";

export const scheduleSubjectsApi = createApi({
  reducerPath: "scheduleSubjectsApi",
  baseQuery: baseAuthQuery("scheduleSubjects"),
  tagTypes: ["Schedule", "ScheduleSubject"],
  endpoints: (builder) => ({
    updateScheduleSubject: builder.mutation<ApiResponse<ScheduleSubjectResponse>, Partial<ScheduleSubjectRequest>>({
      query: (body) => ({
        url: "CreateOrUpdate",
        method: "POST",
        body,
      }),
      async onQueryStarted({ scheduleId }, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(scheduleApi.util.invalidateTags([{ type: "Schedule", id: scheduleId }]));
      },
    }),
    deleteScheduleSubject: builder.mutation<ApiResponse<ScheduleSubjectResponse>, number>({
      query: (id) => ({
        url: `Delete/${id}`,
        method: "POST",
      }),
      async onQueryStarted({}, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(scheduleApi.util.invalidateTags([{ type: "Schedule"}]));
      },
    }),
  }),
});
